export var BAND_TYPE;
(function (BAND_TYPE) {
    // PosterItemComponent
    BAND_TYPE["PORT"] = "PORT";
    BAND_TYPE["PRANK"] = "PRANK";
    BAND_TYPE["LAND"] = "LAND";
    BAND_TYPE["LIST_PORT"] = "LIST_PORT";
    BAND_TYPE["GRID_PORT"] = "GRID_PORT";
    BAND_TYPE["GRID_LAND"] = "GRID_LAND";
    BAND_TYPE["SEARCH_PORT"] = "SEARCH_PORT";
    BAND_TYPE["SEARCH_LIST_PORT"] = "SEARCH_LIST_PORT";
    BAND_TYPE["SEARCH_RECOMMEND_PORT"] = "SEARCH_RECOMMEND_PORT";
    BAND_TYPE["SEARCH_LAND"] = "SEARCH_LAND";
    BAND_TYPE["SEARCH_AUTO_RESULT"] = "SEARCH_AUTO_RESULT";
    BAND_TYPE["EPI"] = "EPI";
    // BannerItemComponent
    BAND_TYPE["BAN1"] = "BAN1";
    BAND_TYPE["BAN2"] = "BAN2";
    BAND_TYPE["BAN3"] = "BAN3";
    BAND_TYPE["EMPTY"] = "EMPTY";
    // ImageCategoryComponent
    BAND_TYPE["CHA"] = "CHA";
    // CategoryComponent
    BAND_TYPE["KATE"] = "KATE";
    // DetailListComponent
    BAND_TYPE["META_EPI"] = "META_EPI";
    BAND_TYPE["META_PROGRAM"] = "META_PROGRAM";
    BAND_TYPE["META_MOVIE"] = "META_MOVIE";
    BAND_TYPE["PLAYER_META_PROGRAM"] = "PLAYER_META_PROGRAM";
    BAND_TYPE["ORIGINAL"] = "ORIGINAL";
    BAND_TYPE["PROFILE_IMAGE"] = "PROFILE_IMAGE";
    // newTvingBandType
    BAND_TYPE["VOD_BASIC"] = "VOD_BASIC";
    BAND_TYPE["VOD_BASIC_MULTI"] = "VOD_BASIC_MULTI";
    BAND_TYPE["VOD_LASTS"] = "VOD_LASTS";
    BAND_TYPE["VOD_BASIC_RANKING"] = "VOD_BASIC_RANKING";
    BAND_TYPE["VOD_BASIC_ORIGINAL"] = "VOD_BASIC_ORIGINAL";
    BAND_TYPE["VOD_SPECIAL_BUTTON"] = "VOD_SPECIAL_BUTTON";
    BAND_TYPE["VOD_BASIC_SPECIAL"] = "VOD_BASIC_SPECIAL";
    BAND_TYPE["VOD_BASIC_CONTENT"] = "VOD_BASIC_CONTENT";
    BAND_TYPE["VOD_EPISODE"] = "VOD_EPISODE";
    BAND_TYPE["LIVE_BASIC"] = "LIVE_BASIC";
    BAND_TYPE["LIVE_RANKING"] = "LIVE_RANKING";
    BAND_TYPE["BANNER_LINE1"] = "BANNER_LINE1";
    BAND_TYPE["BANNER_LINE2"] = "BANNER_LINE2";
    BAND_TYPE["LIVE_ONAIR"] = "LIVE_ONAIR";
    BAND_TYPE["BANNER_MAIN"] = "BANNER_MAIN";
    BAND_TYPE["VOD_CATEGORY"] = "VOD_CATEGORY";
    BAND_TYPE["VOD_BASIC_PURCHASE"] = "VOD_BASIC_PURCHASE";
})(BAND_TYPE || (BAND_TYPE = {}));
export var BAND_WIDTH = 1530;
export var LIST_WIDTH = 1700;
export var FOCUS_INTERVAL = 500;
export var LONG_FOCUS_INTERVAL = 3000;
export var ROLLING_INTERVAL = 10000;
export var BAND_REFRESH_KEY = true;
export var BAND_ITEM_SIZE = {
    PORT: { width: 229, height: 330 },
    PRANK: { width: 229, height: 330, posterWidth: 229, singleRankWidth: 102, doubleRankWidth: 142, overTwentyRankWidth: 180 },
    EPI: { width: 229, height: 330 },
    // EPI: { width: 320, height: 180 },
    LAND: { width: 327, height: 184 },
    LIST_PORT: { width: 229, height: 330 },
    SEARCH_LIST_PORT: { width: 252, height: 356 },
    SEARCH_PORT: { width: 229, height: 330 },
    SEARCH_RECOMMEND_PORT: { width: 229, height: 330 },
    SEARCH_LAND: { width: 229, height: 330 },
    SEARCH_AUTO_RESULT: { width: 229, height: 330 },
    BAN1: { width: 1698, height: 200 },
    BAN2: { width: 842, height: 245 },
    BAN3: { width: 555, height: 279 },
    EMPTY: { width: 1708, height: 312 },
    CHA: { width: 320, height: 180, posterWidth: 320, posterHeight: 200 },
    KATE: { width: 327, height: 100 },
    META_EPI: { width: 1099, height: 258, posterWidth: 460, posterHeight: 258 },
    META_PROGRAM: { width: 1099, height: 258, posterWidth: 460, posterHeight: 258 },
    PLAYER_META_PROGRAM: { width: 1099, height: 258, posterWidth: 460, posterHeight: 258 },
    META_MOVIE: { width: 1099, height: 258, posterWidth: 460, posterHeight: 258 },
    ORIGINAL: { width: 327, height: 654 },
    PROFILE_IMAGE: { width: 249, height: 249 },
    // newTving
    GRID_PORT: { width: 229, height: 330 },
    GRID_LAND: { width: 327, height: 236, posterHeight: 184 },
    VOD_BASIC: { width: 229, height: 330 },
    VOD_BASIC_MULTI: { width: 229, height: 330 },
    VOD_LASTS: { width: 229, height: 330 },
    VOD_BASIC_RANKING: { width: 229, height: 330, posterWidth: 229, singleRankWidth: 102, doubleRankWidth: 142, overTwentyRankWidth: 180 },
    VOD_BASIC_ORIGINAL: { width: 327, height: 654 },
    VOD_SPECIAL_BUTTON: { width: 413, height: 160 },
    VOD_BASIC_SPECIAL: { width: 229, height: 330, specialWidth: 474 },
    VOD_BASIC_CONTENT: { width: 229, height: 330 },
    VOD_EPISODE: { width: 327, height: 236, posterHeight: 184 },
    LIVE_BASIC: { width: 249, height: 249 },
    LIVE_RANKING: { width: 249, height: 249 },
    BANNER_LINE1: { width: 1698, height: 200 },
    BANNER_LINE2: { width: 842, height: 245 },
    LIVE_ONAIR: { width: 556, height: 407, posterHeight: 313 },
    BANNER_MAIN: { width: 274, height: 154, posterHeight: 654 },
    VOD_CATEGORY: { width: 327, height: 100 },
    VOD_BASIC_PURCHASE: { width: 229, height: 330 },
};
// cms 편성이 아닌 내부 생성 띠에 대한 ID 를 정의합니다.
export var BAND_ID = {
    SEARCH_PROGRAM: 'SEARCH_PROGRAM',
    SEARCH_MOVIE: 'SEARCH_MOVIE',
    SEARCH_AUTO_RESULT: 'SEARCH_AUTO_RESULT',
    SEARCH_RECOMMEND_PROGRAM: 'SEARCH_RECOMMEND_PROGRAM',
    SEARCH_RECOMMEND_MOVIE: 'SEARCH_RECOMMEND_MOVIE',
};
